import { motion } from "framer-motion";

export default function QuestionCard({ question, total, onSelect }) {
  return (
    <motion.div
      key={question.id}
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -30 }}
      transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      className="w-full max-w-2xl mx-auto"
      data-testid={`question-${question.id}`}
    >
      <span className="text-xs font-bold tracking-[0.25em] uppercase text-[#8b5cf6]">
        {question.label} / {String(total).padStart(2, "0")}
      </span>
      <h2 className="mt-5 font-display font-bold tracking-tight text-3xl sm:text-4xl md:text-5xl leading-[1.05] text-white">
        {question.text}
      </h2>
      {question.helper && (
        <p className="mt-4 text-zinc-400 text-base">{question.helper}</p>
      )}

      <div className="mt-10 space-y-3">
        {question.options.map((opt, i) => (
          <motion.button
            key={opt.key}
            onClick={() => onSelect(opt)}
            whileHover={{ y: -3 }}
            whileTap={{ scale: 0.98 }}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.15 + i * 0.07, duration: 0.4 }}
            data-testid={`answer-${question.id}-${opt.key}`}
            className="group w-full text-left rounded-xl border border-white/10 bg-white/[0.03] hover:border-[#8b5cf6] hover:bg-[#6d28d9]/10 px-6 py-5 transition-colors"
          >
            <div className="flex items-center justify-between gap-4">
              <div>
                <span className="block text-lg font-medium text-white">
                  {opt.label}
                </span>
                {opt.badge && (
                  <span className="inline-block mt-1.5 rounded-full bg-[#6d28d9] px-3 py-0.5 text-[11px] font-bold uppercase tracking-wide text-white">
                    {opt.badge}
                  </span>
                )}
                {opt.sub && (
                  <span className="block text-sm text-zinc-500 mt-0.5">
                    {opt.sub}
                  </span>
                )}
              </div>
              <span className="flex-shrink-0 h-8 w-8 rounded-full border border-white/20 group-hover:border-[#8b5cf6] group-hover:bg-[#8b5cf6] flex items-center justify-center transition-colors">
                <span className="h-2 w-2 rounded-full bg-white/40 group-hover:bg-white transition-colors" />
              </span>
            </div>
          </motion.button>
        ))}
      </div>
    </motion.div>
  );
}
